/**
 * 消息整合相关常量
 */

// 公告类型映射 (基于etao_notice.category字段)
export const NOTICE_CATEGORY_MAP = {
    1: '系统公告',
    2: '业务通知',
    3: '维护公告',
    4: '紧急通知'
}

// 目标范围映射
export const TARGET_SCOPE_MAP = {
    'ALL': '全体用户',
    'DEPT': '指定部门',
    'ROLE': '指定角色',
    'SPECIFIC': '指定用户'
}

// 公告状态映射 (基于etao_notice.status字段)
export const NOTICE_STATUS_MAP = {
    0: '草稿',
    1: '已发布',
    2: '已过期',
    3: '已取消'
}

// 消息优先级映射
export const MESSAGE_PRIORITY_MAP = {
    'HIGH': '高',
    'NORMAL': '普通',
    'LOW': '低'
}

// 消息状态颜色映射
export const MESSAGE_STATUS_COLOR = {
    'DRAFT': '#909399', // 灰色
    'PUBLISHED': '#67C23A', // 绿色
    'EXPIRED': '#F56C6C', // 红色
    'CANCELLED': '#E6A23C', // 橙色
    'PENDING': '#409EFF', // 蓝色
    'SENDING': '#E6A23C', // 橙色
    'SUCCESS': '#67C23A', // 绿色
    'FAILED': '#F56C6C', // 红色
    'PARTIAL': '#E6A23C' // 橙色
}

// 公告类型图标映射
export const NOTICE_CATEGORY_ICON = {
    1: 'el-icon-document',
    2: 'el-icon-message',
    3: 'el-icon-setting',
    4: 'el-icon-warning'
}

// 消息来源图标映射
export const MESSAGE_SOURCE_ICON = {
    'SYSTEM_ANNOUNCEMENT': 'el-icon-bell',
    'BUSINESS_MESSAGE': 'el-icon-message',
    'MANUAL_SEND': 'el-icon-edit',
    'SCHEDULED_TASK': 'el-icon-timer',
    'API_CALL': 'el-icon-link',
    'SYSTEM_MONITOR': 'el-icon-monitor'
}

// 业务集成配置
export const BUSINESS_INTEGRATION = {
    // 支持的业务类型
    SUPPORTED_BIZ_TYPES: [
        'PRODUCTION',
        'QMS',
        'EQUIPMENT',
        'WAREHOUSE',
        'PURCHASE',
        'SALES'
    ],
    // 自动推送的业务事件
    AUTO_PUSH_EVENTS: [
        'ALARM',
        'EXCEPTION',
        'URGENT',
        'CRITICAL'
    ],
    // 需要确认的消息类型
    CONFIRM_REQUIRED_TYPES: [
        'SYSTEM_ANNOUNCEMENT',
        'URGENT'
    ]
}



// WEBPACK FOOTER //
// ./src/const/messageConst.js